import script from "./Feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=7d3b9fdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3b9fdd"]])

export default __exports__